<script>
    export let location, type, time; 
</script>

<div class="bg-white drop-shadow py-4 px-6 rounded text-black my-4 hover:scale-105 duration-300">
    <div class="flex justify-between w-64 lg:w-96">
        <h1 class="text-base lg:text-xl">{location}</h1>
        <p class="text-base lg:text-xl">{type}</p>
    </div>
    <p class="text-4xl font-bold">{time}</p>
</div>